export default class ChangeSecretForm {
  constructor (data) {
    this.id = data.id;
    this.oldSecret = data.oldSecret;
    this.newSecret = data.newSecret;
  }
}
